import FeatureGates from "@atlaskit/feature-gate-js-client";

import { StatsigFeatureGateKey } from "@/feature-gates/types";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { JourneyLocalStorage } from "@/utils/local-storage-hook.tsx";

import { getLocalStorage } from "../../../utils/localstorage.ts";

import { ufoEventBxpGatewayAnchorParse, ProductKey } from "./";

export function getSignupContext({
    productKey,
    testingPurposes,
    signupId,
    search,
    locale
}: {
    productKey: string;
    testingPurposes: boolean;
    search: string;
    signupId?: string;
    locale?: string;
}) {
    const searchParameters = new URLSearchParams(search);
    const templateId = searchParameters.get("templateId");
    const publicLinkId = searchParameters.get("publicLinkId");

    const signupContext = {};

    if (templateId) {
        Object.assign(signupContext, { templateId });
    }

    if (testingPurposes) {
        Object.assign(signupContext, { testingPurposes: true });
    }

    if (signupId) {
        Object.assign(signupContext, { signupId });
    }

    const anchorLocalStorage = getLocalStorage("onboarding-journey");
    if (anchorLocalStorage) {
        try {
            ufoEventBxpGatewayAnchorParse.start({
                productKey: productKey as ProductKey,
                webPlatform: "bxp-ui"
            });

            const localStorageObj: JourneyLocalStorage =
                JSON.parse(anchorLocalStorage);
            if (localStorageObj) {
                const bxpGatewayAnchor = {
                    anchor: localStorageObj.anchor?.name,
                    type: localStorageObj.anchor?.type,
                    team: localStorageObj.team,
                    persona: localStorageObj.persona,
                    keyword: localStorageObj.keyword,
                    timestamp: new Date()
                };
                Object.assign(signupContext, { bxpGatewayAnchor });
            }

            ufoEventBxpGatewayAnchorParse.success({
                customData: {
                    reactComponent: "getSignupContext",
                    analyticsEvent: "succeeded"
                }
            });
        } catch (error) {
            ufoEventBxpGatewayAnchorParse.failure({
                customData: {
                    reactComponent: "getSignupContext",
                    analyticsEvent: "error",
                    anchorLocalStorage
                },
                error
            });
        }
    }

    const confluencePublicLinkEnabled = FeatureGates.checkGate(
        StatsigFeatureGateKey.BXPSU_2854_CONFLUENCE_PUBLIC_LINK
    );
    if (
        productKey === ProductKey.CONFLUENCE &&
        publicLinkId &&
        confluencePublicLinkEnabled
    ) {
        Object.assign(signupContext, {
            publicLinkId: decodeURIComponent(publicLinkId)
        });
    }

    if (
        locale &&
        checkFeatureFlagGate(featureFlags.passLocaleInSignupContext)
    ) {
        Object.assign(signupContext, { locale });
    }

    return signupContext;
}
